import React from "react";

export default function Footer() {
  return (
    <div>
      <footer className="lg:pt-[100px] pt-[50px] text-center">
        <div className="container lg:px-10 px-4">
          <div className="mb-[40px] max-w-[1000px] mx-auto lg:px-10 px-2">
            <h3 className="text-center font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] lg:text-[35px] sm:text-[25px] text-[22px] mb-8">
              Get news and updates
            </h3>
            <p className="text-center lg:text-[20px] sm:text-[15px] text-[14px]">
              Sign up here so you don't miss a single newsletter
            </p>
            <form action="#" className="mt-[60px]">
              <div className="items-center mx-auto mb-3 space-y-4 max-w-screen-sm sm:flex sm:space-y-0">
                <div className="relative w-full">
                  <label
                    htmlFor="email"
                    className="hidden mb-2 text-sm font-medium text-gray-900"
                  >
                    Email address
                  </label>
                  <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                    <svg
                      className="w-5 h-5 text-gray-500 d"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                  <input
                    className="block p-3 pl-10 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 sm:rounded-none sm:rounded-l-lg focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Enter your email"
                    type="email"
                    id="email"
                    required
                  />
                </div>
                <div>
                  <button
                    type="submit"
                    className="py-3 bg-[#751efe] px-5 w-full text-sm font-medium text-center text-white rounded-lg border cursor-pointer bg-primary-700 border-primary-600 sm:rounded-none sm:rounded-r-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300"
                  >
                    Subscribe
                  </button>
                </div>
              </div>
            </form>
            <div className="flex justify-center gap-8 mt-[50px] mb-8">
              <a href="javascript:void(0);">
                <img src="assets/Vector.svg" />
              </a>
              <a href="javascript:void(0);">
                <img src="assets/twitter.svg" />
              </a>
              <a href="javascript:void(0);">
                <img src="assets/telegram.svg" />
              </a>
            </div>
            <div>
              <a
                href="mailto:info@Globalmentor.io"
                className="lg:text-[22px] text-[#751efe] hover:text-transparent bg-clip-text bg-gradient-to-r from-[#6f30fd] to-[#45adf4] font-bold lg:[16px]"
              >
                info@Globalmentor.io
              </a>
            </div>
            <div>
              <i className="font-bold inline-block mt-8 mb-4">Disclaimer:</i>
            </div>
            <i className="font-[600] lg:text-[16px] text-[14px] inline-block">
              Cryptocurrency may be unregulated in your jurisdiction. The value
              of cryptocurrencies may go down as well as up. Profits may be
              subject to capital gains or other taxes applicable in your
              jurisdiction.
            </i>
          </div>
        </div>
        <div className="flex md:flex-row flex-col justify-between text-white py-6 bg-[#751efe] lg:px-[50px] px-4">
          <div>
            <p className="lg:text-[16px] text-[15px]">
              GLOBAL MENTOR. © 2023. All rights reserved.
            </p>
          </div>
          <div>
            <div className="flex gap-4 md:mt-0 mt-8 justify-center">
              <a href="" className="lg:uppercase lg:text-[16px] text-[15px]">
                Privacy Poicy
              </a>
              <a href="" className="lg:uppercase lg:text-[16px] text-[15px]">
                Terms Of Use
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
